export const shipmentHeaders = {
  containerNo: {
    name: "Container",
    width: 0.3,
  },
  location: {
    name: "Location",
    width: 0.2,
  },
  ETD: {
    name: "ETD",
    width: 0.25,
  },
  ETA: {
    name: "ETA",
    width: 0.25,
  },
  shippingLine: {
    name: "Shipping Line",
    width: 0.3,
  },
  sealNo: {
    name: "Seal No.",
    width: 0.3,
  },
  generatedBy: {
    name: "Created By",
    width: 0.25,
  },
  approvedBy: {
    name: "Approved By",
    width: 0.25,
  },
  createdAt: {
    name: "Created Date",
    width: 0.35,
  },
  shipmentActions: {
    name: "",
    width: 0.15,
    textAlign: "center",
  },
};

export const globalShipmentHeaders = {
  containerNo: {
    name: "Container",
    width: 0.3,
  },
  location: {
    name: "Location",
    width: 0.2,
  },
  ETD: {
    name: "ETD",
    width: 0.25,
  },
  ETA: {
    name: "ETA",
    width: 0.25,
  },
  shippingLine: {
    name: "Shipping Line",
    width: 0.3,
  },
  sealNo: {
    name: "Seal No.",
    width: 0.3,
  },
  generatedBy: {
    name: "Created By",
    width: 0.25,
  },
  createdAt: {
    name: "Created Date",
    width: 0.35,
  },
  shipmentActions: {
    name: "",
    width: 0.15,
    textAlign: "center",
  },
};

export const mdShipmentHeaders = {
  containerNo: {
    name: "Container",
    width: 0.4,
  },
  ETD: {
    name: "ETD",
    width: 0.25,
  },
  ETA: {
    name: "ETA",
    width: 0.25,
  },
  sealNo: {
    name: "Seal No.",
    width: 0.3,
  },
  createdAt: {
    name: "Created Date",
    width: 0.3,
  },
  shipmentActions: {
    name: "",
    width: 0.2,
    textAlign: "right",
  },
};

export const smShipmentHeaders = {
  containerNo: {
    name: "Container",
    width: 0.5,
  },
  ETD: {
    name: "ETD",
    width: 0.3,
  },
  ETA: {
    name: "ETA",
    width: 0.3,
  },
  shipmentActions: {
    name: "",
    width: 0.2,
    textAlign: "center",
  },
};

export const mdNestedShipmentHeaders = {
  orderNumber: {
    name: "Order No.",
    width: 0.15,
  },
  // Sits beside the order number because it qualifies it: a 走库存 split carries the
  // same order number as the ordered half of the same line, so the two rows are
  // otherwise distinguishable only by quantity.
  fromStock: {
    name: "Stock",
    width: 0.15,
    textAlign: "center",
  },
  chinaItemCode: {
    name: "Item Code",
    width: 0.15,
  },
  itemCode: {
    name: "Item Code",
    width: 0.15,
  },
  itemDescription: {
    name: "Item Name",
    width: 0.5,
  },
  qtyTotal: {
    name: "Qty",
    width: 0.12,
  },
  gwTotal: {
    name: "Gross Weight",
    width: 0.15,
  },
  nwTotal: {
    name: "Net Weight",
    width: 0.15,
  },
};

export const smNestedShipmentHeaders = {
  chinaItemCode: {
    name: "Item Code",
    width: 0.4,
  },
  qtyTotal: {
    name: "Qty",
    width: 0.3,
  },
};

export const smGlobalShipmentHeaders = {
  containerNo: {
    name: "Container",
    width: 0.5,
  },
  ETD: {
    name: "ETD",
    width: 0.3,
  },
  ETA: {
    name: "ETA",
    width: 0.3,
  },
  shipmentActions: {
    name: "",
    width: 0.2,
    textAlign: "center",
  },
};

export const mdGlobalNestedShipmentHeaders = {
  orderNumber: {
    name: "Order No.",
    width: 0.15,
  },
  itemCode: {
    name: "Item Code",
    width: 0.15,
  },
  itemDescription: {
    name: "Item Name",
    width: 0.5,
  },
  qtyTotal: {
    name: "Qty",
    width: 0.12,
  },
  gwTotal: {
    name: "Gross Weight",
    width: 0.15,
  },
  nwTotal: {
    name: "Net Weight",
    width: 0.15,
  },
};

export const smGlobalNestedShipmentHeaders = {
  itemCode: {
    name: "Item Code",
    width: 0.4,
  },
  qtyTotal: {
    name: "Qty",
    width: 0.3,
  },
};
